<p-button
  *ngIf="layoutService.darkTheme(); else darkThemeButton"
  styleClass="h-2rem w-2rem p-3 flex align-items-center justify-content-center text-700 overflow-visible"
  [text]="true"
  [rounded]="true"
  (onClick)="layoutService.darkTheme.set(false)"
>
  <i class="pi pi-sun text-xl"> </i>
</p-button>

<ng-template #darkThemeButton>
  <p-button
    styleClass="h-2rem w-2rem p-3 flex align-items-center justify-content-center text-700 overflow-visible"
    [text]="true"
    [rounded]="true"
    (onClick)="layoutService.darkTheme.set(true)"
  >
    <i class="pi pi-moon text-xl"> </i>
  </p-button>
</ng-template>
